import React, { useEffect, useState, useRef } from "react";
import { getFileUrl } from "./utils/getFileUrl";

const baseURL = process.env.REACT_APP_BASE_URL || "";

const FileLink = ({
  fileName,
  target = "_blank",
  children,
  className = "",
  title,
  style = {},
  role,
  ...props
}) => {
  const [fileUrl, setFileUrl] = useState("");
  const [error, setError] = useState(null);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    const resolveFileUrl = async () => {
      try {
        if (!fileName) return;

        let resolvedUrl = "";

        if (fileName.startsWith("/static/") || fileName.startsWith("data:")) {
          resolvedUrl = fileName;
        } else if (fileName.startsWith("/uploads/")) {
          resolvedUrl = baseURL + fileName;
        } else {
          resolvedUrl = await getFileUrl(fileName);
        }

        if (isMounted.current) setFileUrl(resolvedUrl);
      } catch (err) {
        if (isMounted.current) {
          console.error("Error fetching file URL:", err);
          setError(err);
        }
      }
    };

    resolveFileUrl();

    return () => {
      isMounted.current = false;
    };
  }, [fileName]);

  if (!fileUrl) return null;

  return (
    <a
      href={fileUrl}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      className={className}
      title={title}
      style={style}
      role={role}
      {...props}
    >
      {children || "Download File"}
    </a>
  );
};

export default FileLink;
